import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import Datagrid from "../Components/Datagrid";
import DatagridContext from "../Context/datagridContext";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import toolbar from "../Config/toolbarConfig";
import editSettings from "../Config/editSettingsConfig";
import { useTranslation } from "react-i18next";
import Uploader from "../Components/Uploader";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { useNavigate } from "react-router-dom";
import { MaskedTextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
const ContactsPage = () => {
  const [url, setUrl] = useState("");
  const [from, setFrom] = useState("");
  const [status, setStatus] = useState(null);
  const { t } = useTranslation();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Contacts")} | Netileti`);
  const navigate = useNavigate();
  const getData = async () => {
    setUrl(`${baseUrl}/contacts`);
    setFrom("Contacts");
  };

  // const refreshGrid = () => {
  //   const gridElement = document.getElementById("adaptivebrowser");
  //   if (gridElement) {
  //     const grid = gridElement.ej2_instances[0];
  //     grid.refresh();
  //   }
  // };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [status]);

  const editTemplate = (props) => {
    return (
      <MaskedTextBoxComponent
        id={`phoneNumber_${props.rowIndex}`}
        name="phoneNumber"
        placeholder={t("Phone Number")}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              target: {
                name: "phoneNumber",
                value: e.value,
              },
            });
          }
        }}
        mask={"+90 (000)-000-0000"}
        value={props.phoneNumber || ""}
        floatLabelType="Always"
      />
    );
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue.length !== 12) return value;

    return `+${numericValue.slice(0, 2)} (${numericValue.slice(
      2,
      5
    )})-${numericValue.slice(5, 8)}-${numericValue.slice(8)}`;
  };

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "code",
      headerText: t("Code"),
      allowEditing: true,
      validationRules: { required: true, maxLength: 50 },
    },
    {
      field: "taxNumber",
      headerText: t("TaxNumber"),
      allowEditing: true,
      validationRules: { required: true, number: true, maxLength: 11 },
    },
    {
      field: "definition",
      headerText: t("Definition"),
      allowEditing: true,
      validationRules: { maxLength: 50 },
    },
    {
      field: "address",
      headerText: t("Address"),
      allowEditing: true,
      validationRules: { maxLength: 100 },
    },
    {
      field: "city",
      headerText: t("City"),
      allowEditing: true,
      validationRules: { maxLength: 50 },
    },
    {
      field: "country",
      headerText: t("Country"),
      allowEditing: true,
      validationRules: { maxLength: 50 },
    },
    {
      field: "inCharge",
      headerText: t("InCharge"),
      allowEditing: true,
      validationRules: { maxLength: 50 },
    },
    {
      field: "phoneNumber",
      headerText: t("Phone Number"),
      allowEditing: true,
      editTemplate: editTemplate,
      template: (props) => formatPhoneNumber(props.phoneNumber),
    },
    {
      field: "isEnabled",
      headerText: t("isEnabled"),
      allowEditing: true,
      editType: "booleanedit",
      isCheckbox: "True",
      textAlign: "Center",
      filterTemplate: () => (
              <ComboBoxComponent
                dataSource={[
                  { text: t("gridColumns.True"), value: "True" },
                  { text: t("gridColumns.False"), value: "False" },
      
                ]}
                fields={{ text: "text", value: "value" }}
                change={(e) => {
                  const selectedValue = e.value;
                  const gridElement = document.getElementById("adaptivebrowser");
                  if (gridElement) {
                    const grid = gridElement.ej2_instances[0];
      
                    if (grid) {
                      if (selectedValue) {
                        // Filtreyi uygula
                        grid.filterByColumn("isEnabled", "equal", selectedValue);
                      } else {
                        // Filtreyi temizle
                        grid.removeFilteredColsByField("isEnabled");
                      }
                    }
                  }
                }}
              />
            ),
    },
    {
      field: "",
      headerText: "",
      allowEditing: false,
      textAlign: "center",
      width: "10%",
      template: ({ id, phoneNumber, definition, isEnabled }) => (
        <button
          disabled={!isEnabled}
          onClick={() =>
            navigate(`/sendmessage`, {
              state: { contact: { phoneNumber, definition } },
            })
          }
          className={`e-btn e-primary`}
        >
          {/* {t("SendMessage")} */}
          <span
            className="e-icons e-send"
            style={{ color: isEnabled ? "white" : "grey" }}
          />
        </button>
      ),
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <div className="grid-uploader">
          <DatagridContext.Provider
            value={{
              editSettings,
              toolbar: toolbar("CRUD-EXPORT"),
              url,
              from,
              setStatus,
            }}
          >
            <Datagrid columns={columns} />
          </DatagridContext.Provider>
          <div className="uploader-content">
            <h3 style={{ alignSelf: "baseline", fontWeight: "500" }}>
              {t("AddFromExcel")}
            </h3>
            <Uploader />
            <h3 style={{ alignSelf: "baseline", fontWeight: "500" }}>
              <ButtonComponent
                cssClass="e-css e-btn"
                type="button"
                onClick={() => window.open(`${baseUrl}/contacts/download`)}
              >
                {t("TemplateExcel")}
              </ButtonComponent>
            </h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactsPage;
